import { useEffect } from 'react';

const usePageTitle = (title) => {
  useEffect(() => {
    document.title = `${title} | Your Company Name`;
  }, [title]);
};

export default usePageTitle;